import styled from 'styled-components';

import { OnboardingPage } from '@/pages/Onboarding/components/Page';

export const GreatChoiceStyles = styled(OnboardingPage)`
  ion-content {
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    position: relative;
    padding-bottom: 100px;
    z-index: 2;
    background: transparent;

    &::before {
      display: none;
    }
  }

  .content-wrapper {
    width: 100%;
    max-width: 468px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: flex-end;
    min-height: 0;
    padding-bottom: 24px;
    height: 100%;
    flex: 1 1 auto;
    box-sizing: border-box;
    text-align: center;
    z-index: 2;
  }

  .title {
    margin-bottom: 8px;
  }

  .description {
    margin: 0 16px 36px;
  }
`;

export const BackgroundWrapper = styled.div<{ backgroundImage: string }>`
  width: 100%;
  height: 100%;
  background: ${(props) =>
    props.backgroundImage
      ? `url('${props.backgroundImage}') center/cover no-repeat`
      : '#14111e'};
  position: relative;
  display: flex;
  flex-direction: column;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(
      180deg,
      rgba(0, 0, 0, 0) 43.75%,
      rgba(10, 2, 26, 0.8) 69.09%,
      #0a021a 84.92%
    );
    z-index: 1;
    pointer-events: none;
  }
`;
